"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const images_1 = require("../../../services/images");
const PriceDetail = ({ flightData }) => ((0, jsx_runtime_1.jsxs)("div", { className: "detail", children: [(0, jsx_runtime_1.jsx)("img", { src: images_1.icons.PriceDetail, alt: "" }), (0, jsx_runtime_1.jsxs)("span", { className: "text-detail", children: [flightData.price.toFixed(2), " z\u0142"] })] }));
exports.default = PriceDetail;
